import { render } from "./RegiParcelComp.vue?vue&type=template&id=4f25fa13&scoped=true"
import script from "./RegiParcelComp.vue?vue&type=script&lang=js"
export * from "./RegiParcelComp.vue?vue&type=script&lang=js"

import "./RegiParcelComp.vue?vue&type=style&index=0&id=4f25fa13&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f25fa13"]])

export default __exports__